import React from "react";
import "../../styles/header.scss";

const Header = (props) => {
    const { handleLenderActions, isContractLookup, currentUser } = props;
    const [isShownSubMenuItem, setIsShownSubMenuItem] = React.useState(false);
    const [, setIsShowLenderIdentification] = React.useState(false);
    const [, setLenderAction] = React.useState('');
    // PATU (2026-06-30): the Lender Access menu is the legacy anonymous entry
    // point. Hide it for ANY authenticated session — Contract Holders (as before)
    // AND IdP-authenticated lenders, who now use the main claim buttons. Shows
    // only for anonymous / non-IdP-tenant sessions. Supersedes QA-req Table L4.
    const showLenderMenu = isContractLookup && !currentUser?.authenticated;

    // Surface a Log out action only for IdP-authenticated sessions. The tpa
    // claim is projected onto the principal only by the OIDC cookie path, so
    // (authenticated && tpa) uniquely identifies an IdP-driven session and
    // excludes anonymous and legacy form-driven (self-issued JWT) sessions.
    const showLogout = !!(currentUser?.authenticated && currentUser?.tpa);

    const handleLogout = (e) => {
        if (e) e.preventDefault();
        window.location = window.location.origin + '/signout/' + currentUser.tpa;
    };

    const handleDropdownEvent = (e, value) => {
        handlePreventDefault(e)
        setIsShownSubMenuItem(!isShownSubMenuItem);
        setIsShowLenderIdentification(true);
        setLenderAction(value);
        const data = {
            'isShowLenderIdentification': true,
            'lenderAction': value
        };
        handleLenderActions(data);
    }
    const tpaLogoRoute = window.location.origin + '/GetTPALogo';

    const handlePreventDefault = (e) => {
        e.preventDefault();
    }

    const routeToLandingPage = () => {
        window.location = window.location.origin + '/' + window.location.pathname.split("/")[1];
    }

    return (
        <div className="header">
            <nav className="navbar">
                <div className="logo-block">
                    <img src={tpaLogoRoute} width="auto" height="auto" style={{ minHeight: 45 + 'px', minWidth: 65 + 'px' }} />
                </div>
                <div id="myLinks" className="nav-bar">
                    <div className="hamburger-dropdown">
                        {
                            <button className="drop-btn" data-testid="hamburger-icon-item" onClick={() => { setIsShownSubMenuItem(!isShownSubMenuItem) }}>
                                <i className="fa fa-bars ml-5"></i>
                            </button>
                        }
                        {isShownSubMenuItem && showLenderMenu && (<div data-testid="hamburger-lender-menu" className="dropdown-content">
                            <h4>Lender Access</h4>
                            <a href="#/" data-testid="hamburger-start-claim-item" onClick={(e) => { handleDropdownEvent(e, 'newClaim') }}>Start a Claim</a>
                            <a href="#/" data-testid="hamburger-start-existing-claim" onClick={(e) => { handleDropdownEvent(e, 'existingClaim') }}>View Existing Claim</a>
                        </div>
                        )}
                        {isShownSubMenuItem && !isContractLookup && (<div data-testid="hamburger-exit-menu" className="dropdown-content">
                            <a href="#/" data-testid="hamburger-exit-item" onClick={() => { routeToLandingPage() }}>Exit Claim</a>
                        </div>
                        )}
                        {isShownSubMenuItem && showLogout && (<div data-testid="hamburger-logout-menu" className="dropdown-content">
                            <a href="#/" data-testid="hamburger-logout-item" onClick={handleLogout}>Log out</a>
                        </div>
                        )}
                    </div>
                    <div className="dropdown">
                        {
                            showLenderMenu && <button
                                className="drop-btn"
                                data-testid="lender-access-btn"
                                onClick={() => { setIsShownSubMenuItem(!isShownSubMenuItem) }}
                            >
                                Lender Access
                                <i className="fas fa-caret-down ml-5"></i>
                            </button>
                        }
                        {
                            !isContractLookup && <button
                                className="drop-btn"
                                data-testid="exit-claim-btn"
                                onClick={() => { routeToLandingPage() }}
                            >
                                Exit Claim
                            </button>
                        }
                        {
                            showLogout && <button
                                className="drop-btn"
                                data-testid="logout-btn"
                                onClick={handleLogout}
                            >
                                Log out
                            </button>
                        }
                        {isShownSubMenuItem && showLenderMenu && (<div data-testid="lender-access-submenu" className="dropdown-content">
                            <a href="#/" data-testid="start-claim-item" onClick={(e) => { handleDropdownEvent(e, 'newClaim') }}>Start a Claim</a>
                            <a href="#/" data-testid="start-existing-claim" onClick={(e) => { handleDropdownEvent(e, 'existingClaim') }}>View Existing Claim</a>
                        </div>
                        )}
                    </div>

                </div>
            </nav>
        </div>
    );
};

export default Header;
